import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { Button } from "@opensea/next-ui-kit";
import { Carousel, CarouselContent, CarouselNavigationArrows, CarouselNavigationArrowsNext, CarouselNavigationArrowsPrevious, CarouselNavigationDots, Flex, FlexCenter, IconCallout, ModalBody, SpaceBetween, TextHeading } from "@opensea/ui-kit";
import { ArrowBack, Campaign, Close } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { useState } from "react";
import { WhatsNewModalSlide, WhatsNewModalSlideFragment } from "./WhatsNewModalSlide";
export const WhatsNewModalContentFragment = graphql(`
    fragment WhatsNewModalContent on Announcement {
      id
      ...WhatsNewModalSlide
    }
  `, [WhatsNewModalSlideFragment]);
export function WhatsNewModalContent(t0) {
  const $ = _c(75);
  const {
    slides: slideKeys,
    onClose
  } = t0;
  const t = useTranslations("WhatsNewModalContent");
  const [api, setApi] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  let T0;
  let T1;
  let T2;
  let handleBack;
  let handleContinue;
  let t1;
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== api || $[1] !== onClose || $[2] !== selectedIndex || $[3] !== slideKeys || $[4] !== t) {
    const slides = slideKeys.map(_temp);
    let t11;
    if ($[20] !== api || $[21] !== onClose) {
      t11 = () => {
        if (!api) {
          return;
        }
        if (!api.canScrollPrev()) {
          onClose?.();
          return;
        }
        api.scrollPrev();
      };
      $[20] = api;
      $[21] = onClose;
      $[22] = t11;
    } else {
      t11 = $[22];
    }
    handleBack = t11;
    let t12;
    if ($[23] !== api || $[24] !== onClose) {
      t12 = () => {
        if (!api) {
          return;
        }
        if (!api.canScrollNext()) {
          onClose?.();
          return;
        }
        api.scrollNext();
      };
      $[23] = api;
      $[24] = onClose;
      $[25] = t12;
    } else {
      t12 = $[25];
    }
    handleContinue = t12;
    T2 = ModalBody;
    t9 = "p-0 md:w-[540px]";
    let t13;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <IconCallout fill="text-secondary" icon={Campaign} size={20} />;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    let t14;
    if ($[27] !== t) {
      t14 = t("title");
      $[27] = t;
      $[28] = t14;
    } else {
      t14 = $[28];
    }
    let t15;
    if ($[29] !== t14) {
      t15 = <FlexCenter className="gap-3">{t13}<TextHeading size="sm">{t14}</TextHeading></FlexCenter>;
      $[29] = t14;
      $[30] = t15;
    } else {
      t15 = $[30];
    }
    let t16;
    if ($[31] !== onClose) {
      t16 = <FlexCenter><Button className="rounded-full" icon={Close} onClick={() => onClose?.()} size="sm" variant="secondary" /></FlexCenter>;
      $[31] = onClose;
      $[32] = t16;
    } else {
      t16 = $[32];
    }
    if ($[33] !== t15 || $[34] !== t16) {
      t10 = <SpaceBetween className="rounded-t-xl border-border-1 border-b bg-bg-primary px-6 py-5">{t15}{t16}</SpaceBetween>;
      $[33] = t15;
      $[34] = t16;
      $[35] = t10;
    } else {
      t10 = $[35];
    }
    T1 = Carousel;
    t4 = true;
    t5 = "relative";
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = t17 => {
        const {
          index
        } = t17;
        return setSelectedIndex(index);
      };
      $[36] = t6;
    } else {
      t6 = $[36];
    }
    t7 = setApi;
    t8 = slides.length > 1 ? <div className="mx-6 mt-6"><CarouselNavigationDots className="w-full" dotClassName="h-1.5 w-full" /></div> : undefined;
    t3 = "overflow-hidden";
    T0 = CarouselContent;
    t1 = "relative";
    let t17;
    if ($[37] !== selectedIndex) {
      t17 = (slide, i) => <WhatsNewModalSlide isActive={selectedIndex === i} key={slide.id} slide={slide} />;
      $[37] = selectedIndex;
      $[38] = t17;
    } else {
      t17 = $[38];
    }
    t2 = slides.map(t17);
    $[0] = api;
    $[1] = onClose;
    $[2] = selectedIndex;
    $[3] = slideKeys;
    $[4] = t;
    $[5] = T0;
    $[6] = T1;
    $[7] = T2;
    $[8] = handleBack;
    $[9] = handleContinue;
    $[10] = t1;
    $[11] = t10;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    T0 = $[5];
    T1 = $[6];
    T2 = $[7];
    handleBack = $[8];
    handleContinue = $[9];
    t1 = $[10];
    t10 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  let t11;
  if ($[39] !== T0 || $[40] !== t1 || $[41] !== t2) {
    t11 = <T0 className={t1}>{t2}</T0>;
    $[39] = T0;
    $[40] = t1;
    $[41] = t2;
    $[42] = t11;
  } else {
    t11 = $[42];
  }
  let t12;
  if ($[43] !== t11 || $[44] !== t3) {
    t12 = <div className={t3}>{t11}</div>;
    $[43] = t11;
    $[44] = t3;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  let t13;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <CarouselNavigationArrows variant="overlay"><CarouselNavigationArrowsPrevious className="mx-2.5" /><CarouselNavigationArrowsNext className="mx-2.5" /></CarouselNavigationArrows>;
    $[46] = t13;
  } else {
    t13 = $[46];
  }
  let t14;
  if ($[47] !== T1 || $[48] !== t12 || $[49] !== t4 || $[50] !== t5 || $[51] !== t6 || $[52] !== t7 || $[53] !== t8) {
    t14 = <T1 autoHeight={t4} className={t5} onScroll={t6} setApi={t7}>{t8}{t12}{t13}</T1>;
    $[47] = T1;
    $[48] = t12;
    $[49] = t4;
    $[50] = t5;
    $[51] = t6;
    $[52] = t7;
    $[53] = t8;
    $[54] = t14;
  } else {
    t14 = $[54];
  }
  let t15;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ArrowBack size={16} />;
    $[55] = t15;
  } else {
    t15 = $[55];
  }
  let t16;
  if ($[56] !== t) {
    t16 = t("back");
    $[56] = t;
    $[57] = t16;
  } else {
    t16 = $[57];
  }
  let t17;
  if ($[58] !== handleBack || $[59] !== t16) {
    t17 = <Button className="w-full" icon={t15} onClick={handleBack} variant="secondary">{t16}</Button>;
    $[58] = handleBack;
    $[59] = t16;
    $[60] = t17;
  } else {
    t17 = $[60];
  }
  let t18;
  if ($[61] !== t) {
    t18 = t("continue");
    $[61] = t;
    $[62] = t18;
  } else {
    t18 = $[62];
  }
  let t19;
  if ($[63] !== handleContinue || $[64] !== t18) {
    t19 = <Button className="w-full" onClick={handleContinue}>{t18}</Button>;
    $[63] = handleContinue;
    $[64] = t18;
    $[65] = t19;
  } else {
    t19 = $[65];
  }
  let t20;
  if ($[66] !== t17 || $[67] !== t19) {
    t20 = <Flex className="gap-2 rounded-b-xl border-border-1 border-t bg-bg-primary p-6">{t17}{t19}</Flex>;
    $[66] = t17;
    $[67] = t19;
    $[68] = t20;
  } else {
    t20 = $[68];
  }
  let t21;
  if ($[69] !== T2 || $[70] !== t10 || $[71] !== t14 || $[72] !== t20 || $[73] !== t9) {
    t21 = <T2 className={t9}>{t10}{t14}{t20}</T2>;
    $[69] = T2;
    $[70] = t10;
    $[71] = t14;
    $[72] = t20;
    $[73] = t9;
    $[74] = t21;
  } else {
    t21 = $[74];
  }
  return t21;
}
function _temp(slideKey) {
  return readFragment(WhatsNewModalContentFragment, slideKey);
}